import React, { useEffect, useState } from "react";
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import TableHead from '@mui/material/TableHead';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditNoteIcon from '@mui/icons-material/EditNote';
import Badge from '@mui/material/Badge';
import swal from "sweetalert";
import axios from "axios";
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useMediaQuery  , Grid} from "@mui/material";
interface TablePaginationActionsProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number,
  ) => void;
}

function TablePaginationActions(props: TablePaginationActionsProps) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

function createData(
  ids,
  title,
  Category,
  Issue,
  SubmitStatus,
  RewiveStatus,
  Status,


) {
  return { ids, title, Category, Issue, SubmitStatus, RewiveStatus, Status };
}



const rows = [
  createData(1, 'Frozen yoghurt', "Sample", "Issue", "New Uploaded", "Approve", "Status",),
  createData(2, 'Sample cream sandwich', "Sample", "Issue", "New Uploaded", "Approve", "Status",),
  createData(3, 'Sample Eclair', "Sample", "Issue", "New Uploaded", "Approve", "Status",),
  createData(4, 'Cupcake', "Sample", "Issue", "New Uploaded", "Approve", "Status",),
  createData(5, 'Gingerbread5', "Sample", "Issue", "New Uploaded", "Approve", "Status",),
  createData(6, 'Issue', "Sample", "Issue", "New Uploaded", "Approve", "Status",),
  createData(7, 'Gingerbread7', "Sample", "Issue", "New Uploaded", "Approve", "Status",),
  createData(8, 'Gingerbread8', "Sample", "Issue", "New Uploaded", "Approve", "Status",),
  createData(9, 'Issue', "Sample", "Issue", "New Uploaded", "Approve", "Status",),
].sort((a, b) => (a.SubmitStatus < b.SubmitStatus ? -1 : 1));

const IssuePendingArticle = () => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const [issuePostList, setIssuePostList] = React.useState([]);
  const eventid = localStorage.getItem('eventid')
  React.useEffect(() => {
    axios.get(`api/abstractIssueIndex?id=${eventid}`).then(res => {

      if (res.status === 200) {
        const abstractArticleData = res.data.issueArticle;
        setIssuePostList(abstractArticleData)

      } else {
        swal('Error', "Check API Something Wrong", 'error');

      }
    })

  }, []);


  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - issuePostList.length) : 0;

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [open, setOpen] = useState(false);
  const [singleData, setSingleData] = useState({
    id: '',
    title: '',
    description: '',
    event_id: "",
    status: "",
    image: '',
  });

  const handleClickShowSingleRecord = (id) => {


    axios.get(`api/abstractArticleIssueShow/${id}`).then(res => {

      if (res.status === 200) {
        const data = res.data;
        setSingleData(data)


      } else {
        swal('Error', "Check API Something Wrong", 'error');
      }
    })
    setOpen(true);

  };  //console.log(singleData);

  const handleClose = () => {
    setOpen(false);
  };
  //End

  const abstractIssueDelete = (e, id) => {

    e.preventDefault();
    const thisClicked = e.currentTarget;
    thisClicked.innerText = " Deleting..."

    axios.get(`api/abstractArticleIssueIssuestatus/${id}`).then(res => {

      if (res.data.status === 200) {
        //swal("Success", res.data.message, "success");
        thisClicked.closest("tr").remove();

      }
      else if (res.data.status === 404) {
        this.innText = "delete";
      }
    });

  }
  const isSmallDevice = useMediaQuery('(max-width:600px)');
  return (
    <div style={{ margin: '1%', width: '100vw', marginLeft: '0%' }}>
      <Box sx={{ color: '#000000', }} style={{ marginTop: isSmallDevice ? '15%' : '3%' }}>

        <Card sx={{ width: '82vw', float: 'center' }} >
          <CardContent >
            <Typography component="h1" variant="h5">
              Issue
            </Typography>
            <h4 sx={{ m: 2, color: '#000000' }} >
              <Button sx={{
                float: 'right',
                marginRight: '1%',
                marginTop: '2%',
                ":hover": {
                  color: "white"
                }
              }}
                color='success'
                size='small'
                variant='contained'
                component={Link}
                to="/admin/abstract/pending-article">
                Back
              </Button>
            </h4>
            <Box component="form" noValidate sx={{ mt: 3 }}>
              <TableContainer component={Paper}>
                {
                  isSmallDevice ? (<>
                    {issuePostList?.map((row, i) => (
                      <Grid item xs={12} sm={12} md={12} lg={4}>
                        <Card sx={{ minWidth: 275 }}>
                          <CardContent>
                              <Typography variant="subtitle2">#{i + 1}</Typography>
                              <Typography variant="h6">Issue Title: {row.title}</Typography>
                              <Typography>Abstract Title:   {row.article.title}</Typography>
                              <Typography>AuthorName:   {row.writer && row.writer.name}</Typography>
                              <Typography>Issue Date : {row.issue_date}</Typography>


                            </CardContent>
                            <Button sx={{
                              margin: 1,
                              ":hover": {
                                color: "white"
                              }, backgroundColor: '#145348',
                            }}
                              color='primary'
                              size='small'
                              variant='contained'
                              onClick={(e) => handleClickShowSingleRecord(row.id)}  >
                              <VisibilityIcon />
                            </Button>


                        </Card>
                      </Grid>
                    ))}

                  </>) : (
                    <Table sx={{ minWidth: 700 }} aria-label="custom pagination table">
                      <TableHead>
                        <TableRow sx={{ color: '#FFFFFF' }}>
                          <TableCell > #</TableCell>
                          <TableCell align="left"> Issue</TableCell>
                          <TableCell align="left"> Article</TableCell>
                          <TableCell align="left">Writer Name</TableCell>
                          <TableCell align="left">Issue Date</TableCell>
                          {/* <TableCell align="left">Submit Status</TableCell>
                 <TableCell align="left">Rewive Status</TableCell> */}
                          <TableCell align="center">Status</TableCell>

                          <TableCell align="center" style={{ width: 150 }}>Action</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>

                        {(rowsPerPage > 0
                          ? issuePostList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          : issuePostList
                        ).map((row, i) => (
                          <TableRow key={row.id}>
                            <TableCell component="th" scope="row" style={{ width: 52 }}>
                              {i + 1}
                            </TableCell>
                            <TableCell component="th" scope="row" style={{ width: 52 }}>
                              {row.title}
                            </TableCell>
                            <TableCell style={{ width: 60 }} align="left">
                              {row.article.title}
                            </TableCell>
                            <TableCell style={{ width: 60 }} align="left">
                              {row.writer && row.writer.name}
                            </TableCell>

                            <TableCell style={{ width: 60 }} align="left">

                              {row.issue_date}

                            </TableCell>

                            <TableCell style={{ width: 60 }} align="center">

                              {(() => {
                                if (row.status === 1) {
                                  return (
                                    <> <Badge badgeContent={'Active'} color="success">
                                    </Badge>
                                    </>
                                  )
                                }
                                else {
                                  return (
                                    <> <Badge badgeContent={'Inactive'} color="secondary">
                                    </Badge>
                                    </>
                                  )
                                }

                              })
                                ()}
                            </TableCell>
                            <TableCell style={{ width: 150 }} align="right">

                              <Button sx={{
                                margin: 1,
                                ":hover": {
                                  color: "white"
                                }, backgroundColor: '#145348',
                              }}
                                color='primary'
                                size='small'
                                variant='contained'
                                onClick={(e) => handleClickShowSingleRecord(row.id)}  >
                                <VisibilityIcon />
                              </Button>


                              <Button sx={{
                                ":hover": {
                                  color: "white"
                                }, backgroundColor: '#145348',
                              }}
                                color='primary'
                                size='small'
                                variant='contained'
                                onClick={(e) => abstractIssueDelete(e, row.id)}>
                                <DeleteIcon />
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))}
                        {emptyRows > 0 && (
                          <TableRow style={{ height: 53 * emptyRows }}>
                            <TableCell colSpan={6} />
                          </TableRow>
                        )}
                      </TableBody>
                      <TableFooter>
                        <TableRow>
                          <TablePagination
                            rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                            colSpan={3}
                            count={issuePostList.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            SelectProps={{
                              inputProps: {
                                'aria-label': 'rows per page',
                              },
                              native: true,
                            }}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                          />
                        </TableRow>
                      </TableFooter>
                    </Table>
                  )
                }


              </TableContainer>
            </Box>
          </CardContent>
        </Card>
      </Box>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Title: {singleData.title}
          <br />
        </DialogTitle>
        <DialogTitle id="alert-dialog-title">
          Author: {singleData.writer_name}
        </DialogTitle>
        <DialogTitle id="alert-dialog-title">
          Reviewer: {singleData.reviewer_name}
        </DialogTitle>
        {/* {
          singleData.article_image === "no_image.jpg" ? "" :
            <DialogTitle id="alert-dialog-title">
              <img src={`${singleData.base_url}/abstract/${singleData.article_image}`} width="500" height="400" />
            </DialogTitle>
        } */}

      
        <DialogTitle id="alert-dialog-title" >

        </DialogTitle>
        <Badge badgeContent={'Reject Reason'} color="success" style={{ paddingRight: 10, width: 100 }}>
        </Badge>
        <p style={{ padding: 25 }}>
          {singleData.description}
        </p>

        <DialogTitle id="alert-dialog-title">
          Review Status
          {(() => {
            if (singleData.review_status === 1) {
              return (

                <Badge badgeContent={'Approve'} color="success" style={{ paddingRight: 35 }}>
                </Badge>

              )
            }
            else if (singleData.review_status === 2) {
              return (
                <> <Badge badgeContent={'Pending'} color="primary" style={{ paddingRight: 35 }}>
                </Badge>
                </>
              )
            }
            else {
              return (
                <> <Badge badgeContent={'Reject'} color="secondary" style={{ paddingRight: 35 }}>
                </Badge>
                </>
              )
            }

          })
            ()}
        </DialogTitle>
        <DialogTitle id="alert-dialog-title">
          Status  {(() => {
            if (singleData.status === 1) {
              return (
                <> <Badge badgeContent={'Active'} color="success" style={{ paddingRight: 35 }}>
                </Badge>
                </>
              )
            }
            else {
              return (
                <> <Badge badgeContent={'Inactive'} color="secondary" style={{ paddingRight: 35 }}>
                </Badge>
                </>
              )
            }

          })
            ()}
        </DialogTitle>
        <DialogActions>
          <IconButton onClick={handleClose} >
            <CancelIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default IssuePendingArticle;
